import { render, staticRenderFns } from "./SafetyReport.vue?vue&type=template&id=0c8ef73a&scoped=true"
import script from "./SafetyReport.vue?vue&type=script&lang=js"
export * from "./SafetyReport.vue?vue&type=script&lang=js"
import style0 from "./SafetyReport.vue?vue&type=style&index=0&id=0c8ef73a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ef73a",
  null
  
)

export default component.exports